import React from "react";
import { bool, number, shape, string } from "prop-types";

import {
  Column,
  Container,
  Dropdown,
  List,
  ListItem,
  ListItemLink,
  Title
} from "../MainNav/Dropdown";
import { useMainNavDropdown } from "../MainNav/hooks";
import { MostViewedListing } from "../MostViewedListing";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const BuyMainNavDropdown = ({
  is_full_width,
  is_wide,
  title,
  trending_sale
}) => {
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown({
    event_label: "Sales",
    event_value: trending_sale?.id ? `${trending_sale.id}` : "",
    searchTab: "sales"
  });
  const salesDataGtm = {
    "data-gtm-header-menu": "Sales"
  };
  return (
    <>
      <S.BuyDropdownButton
        ref={dropdownRef}
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        title={title}
      >
        <Dropdown isActive={isActive} role="tooltip">
          <Container isFullWidth={!!is_full_width} isWide={!!is_wide}>
            <Column>
              <Title>Areas</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink href="/for-sale/manhattan" {...salesDataGtm}>
                    Manhattan
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/brooklyn" {...salesDataGtm}>
                    Brooklyn
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/queens" {...salesDataGtm}>
                    Queens
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/bronx" {...salesDataGtm}>
                    Bronx
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/for-sale/staten-island"
                    {...salesDataGtm}
                  >
                    Staten Island
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/new-jersey" {...salesDataGtm}>
                    New Jersey
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/nyc" {...salesDataGtm}>
                    All NYC + NJ
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/apartments-for-sale-near-me"
                    {...salesDataGtm}
                  >
                    Near Me
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isLast>
              <Title>Popular neighborhoods</Title>
              <List>
                <ListItem>
                  <ListItemLink href="/for-sale/ues" {...salesDataGtm}>
                    All Upper East Side
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/tribeca" {...salesDataGtm}>
                    Tribeca
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/williamsburg" {...salesDataGtm}>
                    Williamsburg
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/for-sale/brooklyn-heights"
                    {...salesDataGtm}
                  >
                    Brooklyn Heights
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/park-slope" {...salesDataGtm}>
                    Park Slope
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/ditmas-park" {...salesDataGtm}>
                    Ditmas Park
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/hoboken" {...salesDataGtm}>
                    Hoboken
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/for-sale/jersey-city" {...salesDataGtm}>
                    Jersey City
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/sales/all" {...salesDataGtm}>
                    View All
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isAds>
              {trending_sale ? (
                <MostViewedListing listing={trending_sale} />
              ) : null}
            </Column>
          </Container>
        </Dropdown>
      </S.BuyDropdownButton>
    </>
  );
};

BuyMainNavDropdown.propTypes = {
  is_wide: bool,
  is_full_width: bool,
  trending_sale: shape({
    id: number
  }),
  title: string
};

BuyMainNavDropdown.defaultProps = {
  is_wide: false,
  is_full_width: false,
  trending_sale: undefined,
  title: DEFAULT_DROPDOWN_TITLE
};

export default BuyMainNavDropdown;
